var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 712,
    viewBox: "0 0 725 712",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.716,
    y: 110.443,
    width: 80.6512,
    height: 228.226,
    fill: "#0F141A",
    stroke: "black",
    strokeWidth: 3.43197
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.4445,
    y: 96.716,
    width: 80.6512,
    height: 228.226,
    fill: "#8E59FF",
    stroke: "black",
    strokeWidth: 3.43197
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3,
    y: 191.677,
    width: 74.057,
    height: 176.93,
    stroke: "black",
    strokeWidth: 3.43197
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.737,
    cy: 191.297,
    r: 4.48607,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.71598
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.2542,
    cy: 191.297,
    r: 4.48607,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.71598
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.2542,
    cy: 367.657,
    r: 4.48607,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.71598
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.737,
    cy: 367.657,
    r: 4.48607,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.71598
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.145,
    y: 162.852,
    width: 67.7091,
    height: 187.927,
    rx: 33.8545,
    transform: "rotate(-90 209.145 162.852)",
    fill: "#3AB598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.454,
    y: 163.542,
    width: 69.0909,
    height: 189.309,
    transform: "rotate(-90 208.454 163.542)",
    stroke: "black",
    strokeWidth: 1.38182
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.455,
    cy: 129.001,
    r: 3.10909,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.690909
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.763,
    cy: 129.001,
    r: 3.10909,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.690909
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.8,
    cy: 94.4545,
    r: 3.10909,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.690909
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.8,
    cy: 163.548,
    r: 3.10909,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.690909
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0176 531V559.828L57.0117 550.725L45 552.242L63.0176 531Z",
    fill: "#FF8E26",
    stroke: "black",
    strokeWidth: 0.450439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.556 412.296C34.8055 412.335 52.8687 415.968 69.7143 422.987C86.5598 430.007 101.858 440.275 114.735 453.207C127.612 466.139 137.816 481.48 144.764 498.355C151.712 515.23 155.268 533.309 155.23 551.558L98.3969 551.438C98.4198 540.652 96.3179 529.967 92.2113 519.993C88.1047 510.019 82.0739 500.952 74.4631 493.309C66.8523 485.666 57.8106 479.596 47.8542 475.448C37.8979 471.299 27.2219 469.152 16.4357 469.129L16.556 412.296Z",
    fill: "#FFC466"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.619,
    cy: 489.807,
    r: 6.73784,
    fill: "#8E59FF",
    stroke: "black",
    strokeWidth: 1.68446
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.619,
    cy: 447.689,
    r: 6.73784,
    fill: "#8E59FF",
    stroke: "black",
    strokeWidth: 1.68446
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.619,
    cy: 405.58,
    r: 6.73784,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 1.68446
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.3887,
    y1: 611.08,
    x2: 218.888,
    y2: 611.08,
    stroke: "black",
    strokeWidth: 1.68446
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.2305,
    cy: 611.08,
    r: 7.58007,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.73,
    cy: 611.08,
    r: 7.58007,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.728,
    y1: 611.93,
    x2: 219.728,
    y2: 438.43,
    stroke: "black",
    strokeWidth: 1.68446
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.729,
    cy: 611.084,
    r: 7.58007,
    transform: "rotate(-90 219.729 611.084)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.729,
    cy: 437.584,
    r: 7.58007,
    transform: "rotate(-90 219.729 437.584)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.5 480.075L655 524.242L578.5 568.409V480.075Z",
    fill: "#FFC466",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.75 480.202L595.16 524.242L535.75 568.282V480.202Z",
    fill: "#FF80A8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.562,
    y: 470.5,
    width: 108,
    height: 137,
    transform: "rotate(90 660.562 470.5)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.807,
    cy: 578.672,
    r: 6.5,
    transform: "rotate(90 659.807 578.672)",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.807,
    cy: 471.5,
    r: 6.5,
    transform: "rotate(90 659.807 471.5)",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526.736,
    cy: 471.5,
    r: 6.5,
    transform: "rotate(90 526.736 471.5)",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526.736,
    cy: 578.672,
    r: 6.5,
    transform: "rotate(90 526.736 578.672)",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.833 175.5L549 99L593.167 175.5H504.833Z",
    fill: "#FFC466",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.96 218.25L549 158.84L593.04 218.25H504.96Z",
    fill: "#FF80A8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.893,
    y: 193.891,
    width: 52.848,
    height: 52.848,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.969,
    cy: 194.727,
    r: 3.12831,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.19662
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.727,
    cy: 194.727,
    r: 3.12831,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.19662
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.727,
    cy: 246.453,
    r: 3.12831,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.19662
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.969,
    cy: 246.453,
    r: 3.12831,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.19662
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.48609,
    y: 1.48609,
    width: 197.65,
    height: 197.65,
    transform: "matrix(-1 0 0 1 450.649 368)",
    fill: "#8E59FF",
    stroke: "black",
    strokeWidth: 2.97217
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.74933,
    y: 1.74933,
    width: 180.181,
    height: 180.181,
    transform: "matrix(-1 0 0 1 482.29 422.023)",
    stroke: "black",
    strokeWidth: 3.49866
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.44791,
    cy: 5.44791,
    r: 4.57325,
    transform: "matrix(-1 0 0 1 308.707 418.531)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.74933
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.44791,
    cy: 5.44791,
    r: 4.57325,
    transform: "matrix(-1 0 0 1 489.287 418.531)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.74933
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.44791,
    cy: 5.44791,
    r: 4.57325,
    transform: "matrix(-1 0 0 1 489.287 599.117)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.74933
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.44791,
    cy: 5.44791,
    r: 4.57325,
    transform: "matrix(-1 0 0 1 308.707 599.117)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.74933
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.764,
    y: 381,
    width: 79.3381,
    height: 218.585,
    transform: "rotate(-90 467.764 381)",
    fill: "#8E59FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.764,
    y: 381,
    width: 79.3381,
    height: 218.585,
    transform: "rotate(-90 467.764 381)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.857,
    y: 353.295,
    width: 69.6232,
    height: 204.012,
    transform: "rotate(-90 441.857 353.295)",
    stroke: "black",
    strokeWidth: 3.23829
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.042,
    cy: 284.043,
    r: 4.23291,
    transform: "rotate(-90 442.042 284.043)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.61915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.042,
    cy: 354.036,
    r: 4.23291,
    transform: "rotate(-90 442.042 354.036)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.61915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 646.425,
    cy: 354.036,
    r: 4.23291,
    transform: "rotate(-90 646.425 354.036)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.61915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 646.425,
    cy: 284.043,
    r: 4.23291,
    transform: "rotate(-90 646.425 284.043)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.61915
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.02 286.002C231.354 258.169 246.72 202.602 313.52 203.002C380.32 203.402 396.353 258.502 396.02 286.002",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 284,
    r: 4.5,
    fill: "#F8623F",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 203,
    r: 4.5,
    fill: "#F8623F",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 285,
    r: 4.5,
    fill: "#F8623F",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 257V301.333L339.333 287.333L358 289.667L330 257Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 725,
    height: 712,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract);
export default __webpack_public_path__ + "static/media/Abstract.5d172d0708c0ce22c586f3b861dbdc98.svg";
export { ForwardRef as ReactComponent };